// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"criteria-summary_wrapper__1RKrS","title":"criteria-summary_title__ta5F0"};